import { FilterBar } from "./FilterBar";

interface PageShellProps {
    hero?: React.ReactNode;
    children: React.ReactNode;
}

// Wrapper de todas as views internas do dashboard.
// O Breadcrumb não vive aqui — ele é renderizado DENTRO do hero
// (`PageHeader`) no slot do kicker, pra economizar uma linha vertical.
export function PageShell({ hero, children }: PageShellProps) {
    return (
        <div className="space-y-5 max-w-[1600px] mx-auto">
            {hero}
            <FilterBar />
            {children}
        </div>
    );
}
